/** Peer-reviewed publications cited on the FEAGI marketing page. */
export type ResearchPaper = {
  id: string;
  authors: string;
  title: string;
  venue: string;
  details: string;
  doi: string;
  /** Verified publisher landing page for this DOI (from doi.org redirect). */
  publicationUrl: string;
  keywords: string;
  bibtex: string;
};

/** Canonical doi.org URL for a DOI string (slashes are not percent-encoded). */
export function buildDoiHref(doi: string): string {
  return `https://doi.org/${doi}`;
}

/** Extracts the IEEE Xplore document id from a publication URL. */
export function extractIeeeDocumentId(url: string): string | null {
  const match = url.match(/\/document\/(\d+)/);
  return match ? match[1] : null;
}

export const RESEARCH_PAPERS: ResearchPaper[] = [
  {
    id: "tnnls2020",
    authors: "M. Nadji-Tehrani and A. Eslami",
    title:
      "A Brain-Inspired Framework for Evolutionary Artificial General Intelligence",
    venue: "IEEE Transactions on Neural Networks and Learning Systems",
    details: "vol. 31, no. 12, pp. 5257–5271, Dec. 2020",
    doi: "10.1109/TNNLS.2020.2965567",
    publicationUrl: "https://ieeexplore.ieee.org/document/9034490",
    keywords:
      "evolutionary algorithms, genetic programming, indirect encoding, spiking neural networks",
    bibtex: `@article{nadji2020brain,
  title   = {A Brain-Inspired Framework for Evolutionary Artificial General Intelligence},
  author  = {Nadji-Tehrani, Mohammad and Eslami, Ali},
  journal = {IEEE Transactions on Neural Networks and Learning Systems},
  volume  = {31},
  number  = {12},
  pages   = {5257--5271},
  year    = {2020},
  doi     = {10.1109/TNNLS.2020.2965567},
  publisher = {IEEE}
}`,
  },
  {
    id: "dcas2026",
    authors: "S. S. Mondal, M. Nadji-Tehrani and H. Das",
    title: "FEAGI: A Deterministic and Composable Neuromorphic Framework",
    venue: "2026 IEEE 19th Dallas Circuits and Systems Conference (DCAS)",
    details: "Dallas, TX, USA, 2026, pp. 1–4",
    doi: "10.1109/DCAS69364.2026.11544706",
    publicationUrl: "https://ieeexplore.ieee.org/document/11544706",
    keywords:
      "composable cognitive architectures, deterministic execution, audit and replay, hardware export, ASIC co-design, real-time systems",
    bibtex: `@inproceedings{mondal2026feagi,
  title     = {FEAGI: A Deterministic and Composable Neuromorphic Framework},
  author    = {Mondal, Soumik Sarkar and Nadji-Tehrani, Mohammad and Das, Hrishikesh},
  booktitle = {2026 IEEE 19th Dallas Circuits and Systems Conference (DCAS)},
  pages     = {1--4},
  year      = {2026},
  doi       = {10.1109/DCAS69364.2026.11544706},
  organization = {IEEE}
}`,
  },
  {
    id: "glsvlsi2026",
    authors:
      "S. S. Mondal, M. Nadji-Tehrani, M. H. Kabir, N. N. Chakraborty and H. Das",
    title:
      "A Homeostatic Plasticity-Enabled CMOS Neuron for Energy-Efficient Neuromorphic Application",
    venue: "Proceedings of the Great Lakes Symposium on VLSI 2026 (GLSVLSI '26)",
    details: "Canandaigua, NY, USA, 2026, pp. 790–795",
    doi: "10.1145/3787109.3816390",
    publicationUrl: "https://dl.acm.org/doi/10.1145/3787109.3816390",
    keywords:
      "homeostatic plasticity, CMOS neuron, neuromorphic computing, energy efficiency",
    bibtex: `@inproceedings{mondal2026homeostatic,
  title     = {A Homeostatic Plasticity-Enabled CMOS Neuron for Energy-Efficient Neuromorphic Application},
  author    = {Mondal, Soumya Swaraj and Nadji-Tehrani, Mohammad and Kabir, Md Humaun and Chakraborty, Nishith Nirjhar and Das, Hritom},
  booktitle = {Proceedings of the Great Lakes Symposium on VLSI 2026},
  pages     = {790--795},
  year      = {2026},
  doi       = {10.1145/3787109.3816390},
  address   = {Canandaigua, NY, USA},
  publisher = {ACM}
}`,
  },
  {
    id: "icrc2024",
    authors: "J. Ereifej, K. Araujo, M. Nadji-Tehrani, and R. Kubendran",
    title:
      "A Configurable CPG Controller using Connectome based SNN on FPGA for Robot Locomotion",
    venue:
      "2024 IEEE International Conference on Rebooting Computing (ICRC)",
    details: "pp. 1–7, IEEE, 2024",
    doi: "10.1109/ICRC64395.2024.10937017",
    publicationUrl: "https://ieeexplore.ieee.org/document/10937017",
    keywords: "CPG, connectome, SNN, FPGA, robot locomotion",
    bibtex: `@inproceedings{ereifej2024cpg,
  title     = {A Configurable CPG Controller using Connectome based SNN on FPGA for Robot Locomotion},
  author    = {Ereifej, Joseph and Araujo, Kevin and Nadji-Tehrani, Mohammad and Kubendran, Rajkumar},
  booktitle = {2024 IEEE International Conference on Rebooting Computing (ICRC)},
  pages     = {1--7},
  year      = {2024},
  doi       = {10.1109/ICRC64395.2024.10937017},
  organization = {IEEE}
}`,
  },
];
